<template>
    <v-container fluid>
        <v-row no-gutters v-if="showui">
            <v-col cols="12" sm="12">
                <v-card>
                    <v-snackbar v-model="snackbar" :color="snackColor" multi-line right :timeout="1500" top>{{ snackText }} <v-btn dark text @click="snackbar = false">Скрыть</v-btn></v-snackbar>
                    <v-card-title class="indigo white--text headline">Пользователи и права</v-card-title>
                    <v-row>
                        <v-col cols="12"><v-checkbox v-model="filterNull" label="Показать нераспределенные"></v-checkbox> </v-col>
                    </v-row>
                    <v-row class="pa-4" justify="space-between">
                        <v-col class="d-flex">

                            <v-simple-table dense>
                                <template v-slot:default>
                                    <thead>
                                    <tr>
                                        <th class="text-left">Имя</th>
                                        <th class="text-left">Фамилия</th>
                                        <th class="text-left" width="170">ID Telegram</th>
                                        <th class="text-left">Тип</th>
                                        <th class="text-left">Группа или профессия</th>
                                        <th class="text-left" width="200">Телефон</th>
                                        <th class="text-center">Действия</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr class="info lighten-3">
                                        <td><v-text-field v-model="search.first_name"></v-text-field></td>
                                        <td><v-text-field v-model="search.last_name"></v-text-field></td>
                                        <td><v-text-field v-model="search.telegram_id"></v-text-field></td>
                                        <td><v-select :items="filterTypes" item-text="name" item-value="value" v-model="search.type"></v-select></td>
                                        <td v-if="search.type === 'uk'"><v-select :items="filterGroups" item-text="group_name" item-value="id" v-model="search.group_or_position"></v-select></td>
                                        <td v-else><v-select :items="filterProfs" item-text="position_title" item-value="position_id" v-model="search.group_or_position"></v-select></td>
                                        <td><v-text-field v-model="search.phone"></v-text-field></td>
                                        <td></td>
                                    </tr>
                                    <tr v-for="item in filteredUsers" :key="item.id" :class="(item.group_or_position === null) ? `yellow darken-2` : ``">
                                        <td>{{ item.first_name }}</td>
                                        <td>{{ item.last_name }}</td>
                                        <td>{{ item.telegram_id }}</td>
                                        <td><v-select :items="userTypes" item-text="name" item-value="value" v-model="item.type"></v-select> {{ item.address }}</td>
                                        <td v-if="item.type === 'uk'"><v-select :items="groups" item-text="group_name" item-value="id" v-model="item.group_or_position"></v-select></td>
                                        <td v-else><v-select :items="profs" item-text="position_title" item-value="position_id" v-model="item.group_or_position"></v-select></td>
                                        <td>{{ item.phone }}</td>
                                        <td>
                                            <v-btn @click="saveData(item.id)" :disabled="!item.saveButton" color="success">
                                                <v-icon>save</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                {{ cnsl }}
            </v-col>
        </v-row>
        <v-row class="text-center" v-if="!showui">
            <h3>У вас нет доступа в этот раздел!</h3>
        </v-row>
    </v-container>
</template>
<script>
  import moment from 'moment'
  import tz from 'moment-timezone'
  import Fingerprint2 from 'fingerprintjs2'

  const pause = ms => new Promise(resolve => setTimeout(resolve, ms))

  export default {
    data: () => ({
      filterNull: false,
      cnsl: 'test',
      userTypes: [
        {name: 'УК', value: 'uk'},
        {name: 'СТО', value: 'franch'},
      ],
      libaccess: {
        uk: {},
        franch: {}
      },
      approveUsers: [
        '235540743',
        '522086432', //anna iphone
        '504967012' // anna droid
      ],
      search: {
        first_name: '',
        last_name: '',
        phone: '',
        type: '',
        group_or_position: '',
        telegram_id: '',
      },
      showui: false,
      profs: [],
      groups: [],
      dialogAlert: null,
      dialogAlertType: 'info',
      dialog: false,
      open: ['1BbIaUZKN9lnDJWLDKQDLFGflRNet0Scd'],
      users: [],
      accessError: {
        status: false,
        text: null
      },
      loader: true,
      access: false,
      expireDate: moment().unix(),
      fingerprint: null,
      urlParams: null,
      compared: false,
      user: false,
      api: 'https://sbotapi.fitauto.ru/',
      structure: [],
      tree: [],
      snackbar: false,
      snackText: '',
      snackColor: 'success',
    }),
    watch: {

    },
    filters : {

    },
    computed: {
        filterTypes() {
          let utypes = this.userTypes || []
          utypes.push({
            value: 0,
            name: ''
          })
          return utypes
        },
        filterGroups() {
          let groups = this.groups || []
          groups.push({
            id: 0,
            group_name: ''
          })
          return groups
        },
        filterProfs() {
          let profs = this.profs || []
          profs.push({
            position_id: 0,
            position_title: ''
          })
          return profs
        },
        filteredUsers() {
          let users = this.users
          if(this.filterNull === true) users = users.filter(u => u.group_or_position === null)
          if (this.search.first_name.length >= 3) users = users.filter(u => u.first_name.indexOf(this.search.first_name) > -1)
          if (this.search.last_name.length >= 3) users = users.filter(u => u.last_name.indexOf(this.search.last_name) > -1)
          if (this.search.phone.length >= 3) users = users.filter(u => u.phone.indexOf(this.search.phone) > -1)
          if (this.search.telegram_id.length >= 3) users = users.filter(u => u.telegram_id.indexOf(this.search.telegram_id) > -1)
          if (this.search.type > 0) users = users.filter(u => u.type === search.type)
          if (this.search.group_or_position > 0) users = users.filter(u => u.group_or_position === this.search.group_or_position)
          return users
        }
    },
    filters: {},
    methods: {
      async saveData(id) {
        try {
          for(let i in this.users) {
            if(this.users[i].id === id) this.users[i].saveButton = false
          }
          let filtered = this.users.filter(u => u.id === id)
          let data = filtered[0]
          const r = await this.$http.post(`${this.api}v3/telegramuser/save`, data)
          this.showSnack('Данные о пользователе сохранены!')
          for(let i in this.users) {
            if(this.users[i].id === id) this.users[i].saveButton = true
          }
        } catch (e) {
          this.showSnack('Ошибка сохранения! Попробуйте снова.', 'error')
          console.log('save data error:', e)
        }
      },
      async getUsers () {
        try {
          const r = await this.$http.get(`${this.api}v3/gdrive/users`)
          this.users = r.data.map(u => {
            let user = u
            user.saveButton = true
            return user
          })
          this.showSnack('Список пользователей обновлен')
          await pause(1000 * 60 * 10)
          this.getUsers()
        } catch (e) {
          console.log(e)
        }
      },
      getUrlParams: async function () {
        this.loader = true
        this.cnsl += `\nLOADER: ${this.loader}`
        console.log('loader:', this.loader)
        console.log(this.$route.query.id)
        this.cnsl += `\nID: ${this.$route.query.id}`
        if(this.$route.query.id !== null) {
          await this.checkFP()
          this.cnsl += `\nFP: ${this.fingerprint}`
          console.log('FP hash:', this.fingerprint)
          await this.checkCrypto()
          this.cnsl += `\nCOMPARED: ${this.compared}`
          await this.getUsers()
          //await this.getAccess()
          this.loader = false
        } else {
          //редирект
          //this.$router.push('/nonexist')
        }
      },
      async loadChilds (item = null) {

      },
      showSnack: function (text, color = 'success') {
        this.snackText = text
        this.snackColor = color
        this.snackbar = true
      },
      updateUser: async function () {
        try {
          const r = await this.$http.post(`${this.api}v3/telegramuser/setaccess`, {
            id: this.selected.telegram_id,
            access: this.selected.group_or_position,
          })
          console.log('updated:', r.data)
          if(r.data == 'ok') {
            this.selectedChanger = this.selected.group_or_position
          }

        } catch (e) {

          console.log(e)
        }
      },
      getAccess: async function () {
        try {
          const string = `${this.api}v3/access/drive?telegram_id=${this.$route.query.id}&auth_date=${this.$route.query.auth_date}&fp=${this.fingerprint}&sample=ok`
          console.log(string)
          const r = await this.$http.get(string)
          console.log(r.data)
          if(r.data.access === false) {
            this.loader = false
            this.accessError.status = true
            this.accessError.text = r.data.reason
          } else {

            let diff = moment.unix(this.$route.query.auth_date).add(30, 'minutes').diff(moment(), 'seconds')

            if(diff > 0) {
              this.loader = false
              this.access = true
            } else {
              this.loader = false
              this.accessError.status = true
              this.accessError.text = 'Время жизни токена авторизации вышло. Вернитесь в Телеграм и снова нажмите кнопку "В библиотеку"'
            }
          }
        } catch (e) {
          console.log(e)
          this.expireDate = moment().unix()
        }
      },
      checkCrypto: async function () {
        try {
          const r = await this.$http.post(`${this.api}v3/crypto/fithelper`, {
            id: this.$route.query.id,
            first_name: this.$route.query.first_name,
            last_name: this.$route.query.last_name,
            username: this.$route.query.username,
            photo_url: this.$route.query.photo_url,
            auth_date: this.$route.query.auth_date,
            hash: this.$route.query.hash,
          })


          this.cnsl += `\nHASH ${this.$route.query.hash}`
          this.cnsl += `\nCOMPARE STRING ${r.data.compareString}`
          this.cnsl += `\nR DATA ${r.data}`
          this.compared = r.data.compareString === this.$route.query.hash
          console.log('compared', this.compared)
          console.log('find', this.approveUsers.find(e => e == this.$route.query.id))


          if(this.compared && this.approveUsers.find(e => e == this.$route.query.id)) {
            this.showui = true
          }


        } catch (e) {
          console.log(e)
          console.log('Hash checking error!')
        }
      },
      getPositions: async function () {
        try {
          const r = await this.$http.get(`${this.api}service/getpositions`)
          console.log('positions', r.data)
          this.profs = r.data
        } catch (e) {
          console.log(e)
        }
      },
      getGroups: async function () {
        try {
          const r = await this.$http.get(`${this.api}service/getourgroups`)
          console.log('groups', r.data)
          this.groups = r.data
        } catch (e) {
          console.log(e)
        }
      },
      checkFP: async function () {

        function x() {
          let promise = new Promise(function(resolve, reject) {
            if (window.requestIdleCallback) {
              requestIdleCallback(function () {
                Fingerprint2.get(function (components) {
                  const values = components.map(component => component.value )
                  let hash = Fingerprint2.x64hash128(values.join(''), 31)
                  resolve(hash)
                })
              })
            } else {
              window.setTimeout(function () {
                Fingerprint2.get(function (components) {
                  const values = components.map(component => component.value )
                  let hash = Fingerprint2.x64hash128(values.join(''), 31)
                  resolve(hash)
                })
              }, 500)
            }
          });
          return promise
        }
        this.fingerprint = await x()
      }
    },
     mounted () {
      this.getPositions()
      this.getGroups()
      this.getUrlParams()
    },
  }
</script>
<style>

</style>
